module.exports = __webpack_public_path__ + "files/d2ceed7ca4ee4c5adad043df8d4322bb.png";